import { OnInit, EventEmitter } from '@angular/core';
import { MessageType } from '../../models/message';
var MessageComponent = /** @class */ (function () {
    function MessageComponent() {
        /**
         * Auto-dismiss timeout in milliseconds
         *
         * @type {number}
         * @memberof MessageComponent
         */
        this.timeout = 0;
        /**
         * dismiss event
         *
         * @type {EventEmitter<any>}
         * @memberof MessageComponent
         */
        this.dismiss = new EventEmitter();
        this.remove = false;
    }
    Object.defineProperty(MessageComponent.prototype, "classes", {
        get: function () {
            return 'alert alert-' + this.messageType + ' alert-dismissible';
        },
        enumerable: true,
        configurable: true
    });
    MessageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initType();
        // add timeout
        if (this.timeout > 0) {
            this.timeoutId = window.setTimeout(function () { _this.remove = true; }, this.timeout);
        }
    };
    /**
     * raise the dismiss event
     *
     * @memberof MessageComponent
     */
    MessageComponent.prototype.onDismissClicked = function () {
        this.remove = true;
    };
    MessageComponent.prototype.onRemoveDone = function () {
        if (this.remove) {
            this.dismiss.emit(this.message.id);
        }
    };
    /**
     * initialize alert types
     *
     * @private
     * @memberof MessageComponent
     */
    MessageComponent.prototype.initType = function () {
        switch (this.message.type) {
            case MessageType.Success:
                this.messageType = 'success';
                break;
            case MessageType.Information:
                this.messageType = 'info';
                break;
            case MessageType.Waning:
                this.messageType = 'warning';
                break;
            case MessageType.Error:
                this.messageType = 'danger';
                break;
            case MessageType.Debug:
                this.messageType = 'dark';
                break;
        }
    };
    return MessageComponent;
}());
export { MessageComponent };
